import { useEffect, useState } from 'react'

/** Suit une media query CSS depuis React, sans écouteur de redimensionnement manuel. */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const list = window.matchMedia(query)
    const onChange = (event) => setMatches(event.matches)
    setMatches(list.matches)
    list.addEventListener('change', onChange)
    return () => list.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/** Vrai sur les largeurs de téléphone et tablette portrait. */
export function useIsNarrow(maxWidth = 860) {
  return useMediaQuery(`(max-width: ${maxWidth}px)`)
}

/** Vrai quand le pointeur principal ne survole pas (écran tactile). */
export function useIsTouch() {
  return useMediaQuery('(hover: none)')
}
